module.exports = __webpack_public_path__ + "static/36import-5eb5e6cc25574fe6146761c2dc7a9455.png";